<template>
  <span class="pg-avatar"
        :class="size ? '--' + size : ''"
        :style="{ background: picture ? '#fff' : color }"
        :title="page.name">
    <img v-if="picture"
         :src="picture"
         alt=""
         @error="broken = true" />
    <template v-else>{{ letter }}</template>
    <i v-if="!size"
       class="fab fa-facebook-messenger"></i>
  </span>
</template>

<script>
// A Facebook Page's picture, or its first letter on a stable colour when the picture is missing
// or its signed Facebook URL has expired.
const COLORS = ["#1c75bb", "#d6457a", "#FF9800", "#4CAF50", "#673AB7", "#00BCD4"];

export default {
  name: "PageAvatar",
  props: {
    page: { type: Object, required: true },
    size: { type: String, default: "" }, // "" (40px) | "sm" (28px) | "xs" (18px)
  },
  data() {
    return { broken: false };
  },
  computed: {
    picture() {
      return !this.broken && this.page.pictureUrl ? this.page.pictureUrl : null;
    },
    letter() {
      const name = String(this.page.name || "?").trim();
      // Thai leading vowels (เ แ โ ใ ไ) are written before their consonant: keep the pair
      return (/^[\u0E40-\u0E44]/.test(name) ? name.slice(0, 2) : name.charAt(0)).toUpperCase();
    },
    color() {
      const id = String(this.page.pageId || this.page.name || "");
      let sum = 0;
      for (let i = 0; i < id.length; i++) sum = (sum + id.charCodeAt(i)) % 997;
      return COLORS[sum % COLORS.length];
    },
  },
  watch: {
    "page.pictureUrl"() {
      this.broken = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.pg-avatar {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  color: #fff;
  font-weight: 700;
  font-size: 1rem;
  line-height: 1;
  position: relative;
  user-select: none;

  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
  }

  .fab {
    position: absolute;
    right: -3px;
    bottom: -3px;
    font-size: 0.8rem;
    color: $brand-blue-mid;
    background: #fff;
    border-radius: 50%;
    padding: 1px;
  }

  &.--sm {
    width: 28px;
    height: 28px;
    font-size: 0.8rem;
  }

  &.--xs {
    width: 18px;
    height: 18px;
    font-size: 0.6rem;
  }
}
</style>
